<sn-icon-button [disabled]="disabled" [matMenuTriggerFor]="colorMenu">
  <span class="selected-color" [style.background]="value"></span>
</sn-icon-button>
<ng-content></ng-content>

<mat-menu
  #colorMenu="matMenu"
  [yPosition]="yPosition"
  [xPosition]="xPosition"
  class="sn-mat-color-picker-menu"
>
  <header (click)="$event.stopPropagation()" [ngClass]="selectedColor?.className">
    <sn-icon-button *ngIf="view === 'hues'" class="back-button" (click)="back()">
      <sn-icon>arrow_back</sn-icon>
    </sn-icon-button>

    <ng-template [ngIf]="selectedPalette">
      {{ selectedPalette?.key | colorNameTranslation }} {{ selectedColor?.key }}
    </ng-template>
    <ng-template [ngIf]="!selectedPalette">{{ 'common.selectColor' | t }}</ng-template>

    <sn-icon-button *ngIf="value" class="remove-color" (click)="clear()">
      <sn-icon
        fontSet="fal"
        fontIcon="fa-trash-can"
        [matTooltip]="'incidentManagement.dialogs.colorPicker.removeColor' | t" 
        matTooltipPosition="left"
      >
      </sn-icon>
    </sn-icon-button>
  </header>

  <ng-container [ngSwitch]="view">
    <div class="colors" *ngSwitchCase="'palettes'" (click)="$event.stopPropagation()">
      <div
        class="color"
        matRipple
        *ngFor="let color of materialColors; trackBy: trackMaterialColor"
        [ngClass]="color.className"
        (click)="onSelect($event, color)"
      >
        <span class="color-label">{{ color.key | colorNameTranslation }}</span>
      </div>
    </div>

    <div class="colors" *ngSwitchCase="'hues'" (click)="$event.stopPropagation()">
      <div
        class="color"
        matRipple
        *ngFor="let color of selectedPalette?.colors; trackBy: trackMaterialColor"
        [ngClass]="color.className"
        (click)="onSelect($event, color)"
      >
        <span class="color-label">{{ color.key }}</span>
        <sn-icon *ngIf="color === selectedColor">check</sn-icon>
      </div>
    </div>
  </ng-container>
</mat-menu>
